import get from './get'
import discovery from './discovery'
import query from './query'

export default {
    get,
    discovery,
    query,
}
